import { actionsFactory, props } from '@ngneat/effects';
import {
  Driver,
  DriverImport,
  IntegrationType,
  OrphanedResource,
  PagedCollectionParams,
} from '@tmx/data-access';

const driversActions = actionsFactory('drivers');

export const loadDrivers = driversActions.create(
  'Load Drivers',
  props<{ params: PagedCollectionParams }>()
);

export const loadLinkedData = driversActions.create(
  'Load Linked Data',
  props<{ driverIds: string[] }>()
);

export const selectDriver = driversActions.create(
  'Select Driver',
  props<{ driver: Driver | null }>()
);

export const importDrivers = driversActions.create(
  'Import List Of Drivers',
  props<{ drivers: DriverImport[] }>()
);

export const clearImportResponse = driversActions.create(
  'Clear Import Response'
);

export const loadDriversCsv = driversActions.create('Load Drivers Csv File');

export const setDriversOffset = driversActions.create(
  'Set Drivers Offset',
  props<{ offset: number }>()
);

export const setDriversSort = driversActions.create(
  'Set Drivers Sort Properties',
  props<{ sortDirection: '' | 'asc' | 'desc'; sortExpression: string }>()
);

export const setDriversQuery = driversActions.create(
  'Set Drivers Query',
  props<{ query: string }>()
);

export const setDriversRowsDescriptor = driversActions.create(
  'Set Drivers Rows Descriptor To Loading Or Use Current Driver Data',
  props<{ loading: boolean }>()
);

export const removeSelectedDriver = driversActions.create(
  'Remove Selected Driver'
);

export const removeSelectedDriverGroups = driversActions.create(
  'Remove Selected Driver Groups'
);

export const amendDriver = driversActions.create(
  'Remove Driver Groups Assignment Of Driver',
  props<{ driver: Driver; unassignmentDriverGroupIds: number[] }>()
);

export const setCreatingNewDriver = driversActions.create(
  'Set Whether New Driver Is Being Created',
  props<{ creatingNewDriver: boolean }>()
);

export const setPrefilledDriverId = driversActions.create(
  'Set Driver ID To Prefill In Add Edit Modal',
  props<{ id: null | string }>()
);

export const loadDriverOrphans = driversActions.create('Load Driver Orphans');

export const setDriverOrphans = driversActions.create(
  'Set Driver Orphans',
  props<{ orphans: Map<string, OrphanedResource> }>()
);

export const removeFromDrivers = driversActions.create(
  'Delete Driver',
  props<{ driverId: string }>()
);

export const clearDrivers = driversActions.create('Clear Selected Drivers');

export const setDriverErrorMessage = driversActions.create(
  'Set Driver Error',
  props<{ error: null | string }>()
);

export const loadDriverDetails = driversActions.create(
  'Load Driver Details',
  props<{ driverId: null | string }>()
);

export const createDriver = driversActions.create(
  'Create Driver',
  props<{
    drivers: Partial<Driver>[];
    skipSelection?: boolean;
  }>()
);

export const editDriver = driversActions.create(
  'Edit Driver',
  props<{
    drivers: Driver[];
    integrationType: IntegrationType;
    skipSelection?: boolean;
  }>()
);

export const changeDriverGroupAssignments = driversActions.create(
  'Change Driver Group Assignments Of A Driver',
  props<{
    assignmentDriverGroupIds: number[];
    id: number;
    unassignmentDriverGroupIds: number[];
  }>()
);

export const loadDriversGroups = driversActions.create(
  'Load Driver Groups',
  props<{ driverId: string }>()
);

export const resetCurrentStep = driversActions.create(
  'Reset Current Step',
  props<{ currentStep: number }>()
);

export const saveCurrentStep = driversActions.create(
  'Save Current Step',
  props<{ currentStep: number }>()
);

export const triggerTableReload = driversActions.create('Trigger Table Reload');
